<!--
 * @Descripttion:
 * @Version: 1.0.0
 * @Author: liyong
 * @Date: 2022-08-03 16:54:50
 * @LastEditors: liushuaibo liushuaibo@yangxuan.net
 * @LastEditTime: 2023-07-05 11:55:52
 * @FilePath: /partner.chaoyongtuan.com/src/views/shopManage/shopLibrary/list/tableCells/sampleCell.vue
 *
 * Copyright (c) 2022 by 央选/李勇, All Rights Reserved.
-->
<template>
	<div>
		<talent-info @showdetailDrawer="showdetailDrawer" v-if="row.anchor_info.length" :talent-info="row.anchor_info[0]" />
		<el-popover min-width="200" v-if="row.anchor_info.length > 1">
			<div class="pl-12 pr-12 pt-6 pb-6" v-for="(item, index) in row.anchor_info" :key="index">
				<talent-info @showdetailDrawer="showdetailDrawer" v-if="index" :talent-info="item" />
			</div>
			<el-button type="text" slot="reference">查看更多关联达人></el-button>
		</el-popover>
	</div>
</template>
<script>
import mixin from '@/components/tableCells/mixin';
import talentInfo from '../../components/talentInfo';
export default {
	components: {
		talentInfo,
	},
	mixins: [mixin],
	inject: ['showdetailDrawer'],
};
</script>
<style lang="less" scoped>
</style>
